import React from 'react';
import { Tag, Spin } from 'antd';
import { asserts } from '../../../utils';
import './index.less';

const { isFunction } = asserts;
const { CheckableTag } = Tag;

export default ({
  className = '',
  loading,
  dataSource,
  value,
  valueKey = 'code',
  labelKey = 'name',
  onChange,
}) => {
  const handleChange = (value, checked) => {
    const newValue = checked ? value : '';
    isFunction(onChange) && onChange(newValue);
  };

  return (
    <Spin spinning={loading}>
      <div className="orderType-checktag-wrapper">
        {dataSource.map((item, index) => {
          return (
            <CheckableTag
              key={index}
              checked={item[valueKey] === value}
              className={`pointer ${className}`}
              onChange={(checked) => handleChange(item[valueKey], checked)}
            >
              {item[labelKey]}
            </CheckableTag>
          );
        })}
      </div>
    </Spin>
  );
};
